import BaseUser from './BaseUser'
export default class WxUserInfo extends BaseUser{
	constructor({
		city = '',
		province = '',
		country = '中国',
		headimgurl = '',
		nickname = '',
		openid = '',
		remark = '',
		sex = '',
		unionid = ''
	} = {}) {
		super({id: '', nickname, mobile: ''})
	    this.city = city
		this.province = province
		this.country = country
		this.headimgurl = headimgurl
		this.nickname = nickname
		this.openid = openid
		this.remark = remark
		this.sex = sex
		this.unionid = unionid
	}
}